var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24330",
    "data-name": "Group 24330",
    transform: "translate(-1290 -1001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12916",
    "data-name": "Rectangle 12916",
    width: 12,
    height: 12,
    transform: "translate(1290 1001)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_001-user",
    "data-name": "001-user",
    transform: "translate(1261 1002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11997",
    "data-name": "Group 11997",
    transform: "translate(32.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11996",
    "data-name": "Group 11996",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3921",
    "data-name": "Path 3921",
    d: "M123.545,0a2.545,2.545,0,1,0,2.545,2.545A2.548,2.548,0,0,0,123.545,0Z",
    transform: "translate(-121)",
    fill: "#00101a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11999",
    "data-name": "Group 11999",
    transform: "translate(31 5.655)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11998",
    "data-name": "Group 11998",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3922",
    "data-name": "Path 3922",
    d: "M38.408,301.1a3.628,3.628,0,0,0-2.6-1.1H34.676a3.628,3.628,0,0,0-2.6,1.1A3.709,3.709,0,0,0,31,303.714a.283.283,0,0,0,.283.283H39.2a.283.283,0,0,0,.283-.283A3.709,3.709,0,0,0,38.408,301.1Z",
    transform: "translate(-31 -300)",
    fill: "#00101a"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.63f2edb378d0809cd0e7c35836b00b36.svg";
export { ForwardRef as ReactComponent };